import { PageRef } from 'providers/page-ref';

export type TestUiComponentsPageParams = {
  // a card's data-card-id or an example row's data-showcase-id to scroll to
  scrollCard?: string;
};

export const ITestUiComponentsPage: PageRef<TestUiComponentsPageParams, void> = {
  pageName: 'TestUiComponentsPage',
} as PageRef<TestUiComponentsPageParams, void>;
